
const TableauLogistique = function(element, options) {
    this.element  = $(element);
    this.table    = this.element.find('table');
    this.body     = this.table.find('tbody');
    this.options  = options;

    // Gestion du filtrage
    this.defaut = this.options.defaut;
    this.filtre = $.extend({}, this.options.filtre);

    // Stocks utilisateur
    this.userStock = $(this.options.userStock);
    this.stocks = $(this.options.stocks);

    this.btnFiltre = $(this.options.button.filter);
    this.btnRefresh  = $(this.options.button.refresh);
    this.btnSemainePrev = $(this.options.button.semainePrev);
    this.btnSemaineNext = $(this.options.button.semaineNext);

    this.semaine = $(this.options.semaineCourante);

    this.btnFiltre.on('form-success.modal', $.proxy(this.onFiltreSuccess, this));
    this.btnSemainePrev.on('click', $.proxy(this.onSemainePrevClick, this));
    this.btnSemaineNext.on('click', $.proxy(this.onSemaineNextClick, this));
    this.btnRefresh.on('click', $.proxy(this.onRefreshClick, this));

    $(document).on('click', this.options.button.reset, $.proxy(this.onResetClick, this));

    // Rafraichissement du tableau
    // Les modales pouvant s'enchaîner les unes à la suite des autres, les événements des nouvelles sont perdus
    // suite au rafraichissement du tableau (les anciens éléments disparaissant).
    const onFormComplete = (event, response) => {
        if (!response.redirectModal) {
            event.preventDefault();

            event.modal.hide();
        }

        this.refreshLogistique();
    };
    const onModalRedirect = (event, modal) => {
        modal.on('after-form-success.modal', onFormComplete);
        modal.on('redirect-modal.modal', onModalRedirect);
    };

    this.body.on('after-form-success.modal', '[data-toggle="ajax-modal"]', onFormComplete);
    this.body.on('redirect-modal.modal', '[data-toggle="ajax-modal"]', onModalRedirect);

    // Refresh hauteur du tableau
    this.clone = this.table.clone();
    this.clone.find('tbody').remove();
    this.clone.addClass('table-fixed-header');
    this.clone.insertAfter(this.table);

    $(window).on('resize', $.proxy(this.refreshFixedHeader, this));
    $(window).on('scroll', $.proxy(this.fixHeader, this));
    this.refreshFixedHeader();
    this.fixHeader();

    // Hover
    this.body.on('mouseenter mouseover', 'tr', $.proxy(this.onMouseEnterRow, this));
    this.body.on('mouseleave',  $.proxy(this.onMouseLeave, this));

    this.body.on('mouseenter mouseover', 'td.cell-client', $.proxy(this.onMouseEnterClientCell, this));
    this.body.on('mouseleave', 'td.cell-client', $.proxy(this.onMouseLeave, this));

    // Refresh stocks
    this.stocks.on('modal-hide.modal', $.proxy(this.refreshStocks, this))
};

$.extend(TableauLogistique.prototype, {
    onMouseEnterRow: function(event) {
        const row = $(event.currentTarget);

        this.body.find('.hover').removeClass('hover');
        if (row.attr('data-chargement-index')) {
            this.body.find('tr[data-chargement-index="' + row.attr('data-chargement-index') + '"]').addClass('hover');
        }
    },

    onMouseEnterClientCell: function(event) {
        const row = $(event.currentTarget).closest('tr');

        this.body.find('.highlight').removeClass('highlight');
        this.body.find('.hover').removeClass('hover');
        this.body.find('tr[data-chargement-index="' + row.attr('data-chargement-index') + '"]').addClass('hover');
        this.body.find('tr[data-livraison-index="' + row.attr('data-livraison-index') + '"]').addClass('highlight');
    },

    onMouseLeave: function() {
        this.body.find('.highlight').removeClass('highlight');
        this.body.find('.hover').removeClass('hover');
    },

    refreshFixedHeader: function() {
        const headers = this.table.find('thead th'),
            clones = this.clone.find('thead th');

        headers.map((index, header) => {
            $(clones[index]).css('width', $(header).css('width'));
        });

        this.clone.css('width', this.table.css('width'));
    },

    fixHeader: function() {
        if ($(window).scrollTop() > 21) {
            // Show header fixed clone
            this.element.addClass('show-fixed-header');
        } else {
            this.element.removeClass('show-fixed-header');
        }
    },

    refreshStocks: function() {
        $.ajax({
            url: this.userStock.data('user-stock'),
            method: 'get',
            success: response => {
                this.userStock.html(response);
            }
        })
    },

    refreshLogistique: function() {
        this.semaine.text('S' + this.filtre.sdate);

        this.refreshStocks();

        $.ajax({
            url: Routing.generate('tableau_logistique_tableau'),
            data: this.filtre,
            success: response => {
                this.body.html(response);
            }
        });
    },

    onRefreshClick: function(event) {
        event.preventDefault();

        this.refreshLogistique();
    },

    onResetClick: function() {
        this.filtre = $.extend({}, this.defaut);

        $.ajax({
            url: Routing.generate('tableau_logistique_reset'),
            success: () => {
                this.refreshLogistique();
            }
        });
    },

    onFiltreSuccess: function(event, response) {
        this.filtre = response;

        this.refreshLogistique();
    },

    onSemainePrevClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').subtract('1', 'weeks');

        this.filtre.date = date.format('DD/MM/YYYY');
        this.filtre.sdate = date.format('WW');

        this.refreshLogistique();
    },

    onSemaineNextClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').add('1', 'weeks');

        this.filtre.date = date.format('DD/MM/YYYY');
        this.filtre.sdate = date.format('WW');

        this.refreshLogistique();
    }
});

$.fn.tableauLogistique = function(options) {
    return $.each(this, function () {
        new TableauLogistique(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/tableauLogistique.js